// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1keYy","footer":"ModalUpdate_footer__2yaaF"};